<template>
  <div id="">
    <br>
    <b-field grouped group-multiline>
            <b-select v-model="perPage" :disabled="!isPaginated">
                <option value="5">5 per page</option>
                <option value="10">10 per page</option>
                <option value="15">15 per page</option>
                <option value="20">20 per page</option>
            </b-select>
            <div class="control is-flex">
                <b-switch v-model="isPaginated">Paginated</b-switch>
            </div>
        </b-field>

        <b-table
            :data="userData"
            :paginated="isPaginated"
            :per-page="perPage"
            :current-page.sync="currentPage"
            :pagination-simple="isPaginationSimple"
            :default-sort-direction="'asc'"
            default-sort="firstName">

            <template slot-scope="props">
                <b-table-column field="firstName" label="First Name" sortable>
                    {{ props.row.firstName }}
                </b-table-column>

                <b-table-column field="lastName" label="Last Name" sortable>
                    {{ props.row.lastName }}
                </b-table-column>

                <b-table-column field="createdAt" label="Created" sortable>
                    {{ props.row.createdAt }}
                </b-table-column>

                <b-table-column field="email" label="Email" sortable>
                    <a :href="'mailto:' + props.row.email">
                      {{ props.row.email }}
                    </a>
                </b-table-column>

                <b-table-column>
                    <a href="#" @click="confirmDeleteAccount(props.row.id, props.row.displayName)">
                      <b-icon icon="cancel" custom-class="button-danger"></b-icon>
                    </a>
                </b-table-column>

            </template>
        </b-table>
  </div>
</template>
<script>
    import { ToastProgrammatic as Toast } from 'buefy'

export default {
  name: "",
  data() {
    return {
            userData: [],
            isPaginated: true,
            isPaginationSimple: false,
            defaultSortDirection: 'asc',
            currentPage: 1,
            perPage: 5
        }
  },
  computed: {
    userList: function () {

    }
  },
  methods: {
    confirmDeleteAccount(id, displayName) {
        let vm = this;
        this.$dialog.confirm({
            title: 'Deleting account',
            message: 'Are you sure you want to <b>delete</b> "' + displayName + '" account? This action cannot be undone.',
            confirmText: 'Delete Account',
            type: 'is-danger',
            hasIcon: true,
            onConfirm: (function() {

              Toast.open('Account deleted!');
            })
        })
    },
    deleteUser() {
      var user = firebase.auth().currentUser;

        user.delete().then(function() {
          // User deleted.
        }).catch(function(error) {
          // An error happened.
        });
    }
  },
  mounted() {
    // let database = firebase.database();
    // let users = database.ref().child('users')
    let query = firebase.database().ref("users").orderByKey();
    let vm = this;
    query.once("value")
      .then(function(snapshot) {
        snapshot.forEach(function(childSnapshot) {
          let objUser = {};
          var key = childSnapshot.key;
          objUser.id = key;
          console.log('key:' + key);
          // childData will be the actual contents of the child
          var childData = childSnapshot.val();
          objUser.displayName = childData.displayName;
          objUser.email = childData.email;
          objUser.firstName = childData.firstName;
          objUser.lastName = childData.lastName;
          objUser.photoURL = childData.photoURL;
          objUser.createdAt = childData.createdAt;


          objUser.roles = childData.roles;
          if (!objUser.roles.admin) {
            vm.userData.push(objUser);
          }
          console.log('childdata:' + childData.displayName);
      });
      console.log(vm.userData);
      admin.auth().getUser(firebase.auth().currentUser.uid)
        .then(function(userRecord) {
          // See the UserRecord reference doc for the contents of userRecord.
          console.log("Successfully fetched user data:", userRecord.toJSON());
        })
        .catch(function(error) {
          console.log("Error fetching user data:", error);
        });
    });
  }
}
</script>
<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// DeleteUserTab.vue?431cd4ca